import { container, TYPES } from '@antv/l7-core';
import CanvasLayer from './canvas';
import CityBuildingLayer from './citybuliding/building';
import BaseLayer from './core/BaseLayer';
import GeometryLayer from './Geometry';
import './glsl.d';
import HeatmapLayer from './heatmap';
import ImageLayer from './image';
import LineLayer from './line/index';
import PointLayer from './point';
import PolygonLayer from './polygon';
import RasterLayer from './raster';
import EarthLayer from './earth';
import MaskLayer from './mask';
import WindLayer from './wind';
import DataMappingPlugin from './plugins/DataMappingPlugin';
import DataSourcePlugin from './plugins/DataSourcePlugin';
import FeatureScalePlugin from './plugins/FeatureScalePlugin';
import LayerAnimateStylePlugin from './plugins/LayerAnimateStylePlugin';
import LayerModelPlugin from './plugins/LayerModelPlugin';
import LayerStylePlugin from './plugins/LayerStylePlugin';
import LightingPlugin from './plugins/LightingPlugin';
import MultiPassRendererPlugin from './plugins/MultiPassRendererPlugin';
import PixelPickingPlugin from './plugins/PixelPickingPlugin';
import RegisterStyleAttributePlugin from './plugins/RegisterStyleAttributePlugin';
import ShaderUniformPlugin from './plugins/ShaderUniformPlugin';
import UpdateModelPlugin from './plugins/UpdateModelPlugin';
import UpdateStyleAttributePlugin from './plugins/UpdateStyleAttributePlugin';
container.bind(TYPES.ILayerPlugin).to(DataSourcePlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(RegisterStyleAttributePlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(FeatureScalePlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(DataMappingPlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(LayerStylePlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(UpdateStyleAttributePlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(UpdateModelPlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(MultiPassRendererPlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(ShaderUniformPlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(LayerAnimateStylePlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(LightingPlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(PixelPickingPlugin).inRequestScope();
container.bind(TYPES.ILayerPlugin).to(LayerModelPlugin).inRequestScope();
export { BaseLayer, PointLayer, PolygonLayer, LineLayer, CityBuildingLayer, GeometryLayer, CanvasLayer, ImageLayer, RasterLayer, HeatmapLayer, EarthLayer, WindLayer, MaskLayer };
export * from './core/interface';
//# sourceMappingURL=index.js.map